import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { parseEntityRef } from '@backstage/catalog-model';
import { useSystemEntities } from '../../hooks/useSystemEntities';
import { useResetOnParentChange } from '../../hooks/useResetOnParentChange';
import { readSiblingFormData } from '../formContext';
import { EntityRefAutocomplete } from '../EntityRefAutocomplete';
import type {
  SystemPickerUiOptions,
  SystemPickerValue,
} from '../../schemas/systemPickerSchema';

export const SystemPickerField = (
  props: FieldExtensionComponentProps<SystemPickerValue, SystemPickerUiOptions>,
) => {
  const {
    formData,
    onChange,
    schema,
    required,
    rawErrors,
    idSchema,
    uiSchema,
  } = props;

  const domainFieldName = uiSchema?.['ui:options']?.domainField ?? 'domain';
  const domainRefString = readSiblingFormData(props, domainFieldName) as
    | string
    | undefined;
  const domainRef = domainRefString
    ? parseEntityRef(domainRefString, { defaultKind: 'Domain' })
    : undefined;

  const { items, loading, error } = useSystemEntities(domainRef);
  useResetOnParentChange(domainRefString, onChange);

  return (
    <EntityRefAutocomplete
      title={schema.title ?? 'System'}
      description={schema.description}
      required={required}
      rawErrors={rawErrors}
      fieldId={idSchema?.$id}
      value={formData}
      onChange={onChange}
      items={items}
      loading={loading}
      error={error}
      loadingText="Loading systems..."
      errorText="Unable to load Systems from the Catalog."
    />
  );
};
